import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

import Home from "./pages/Home";
import TerminiCondizioni from "./pages/TerminiCondizioni";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import Reclami from "./pages/Reclami";
import Precontrattuale from "./pages/Precontrattuale";
import SocietaBenefit from "./pages/SocietaBenefit";
import SocietaCooperativa from "./pages/SocietaCooperativa";
import Mission from "./pages/Mission";
import Quotazione from "./pages/Quotazione";
import BastaLaTarga from "./pages/BastaLaTarga";
import TrasparenzaReclami from "./pages/TrasparenzaReclami";
import Tirocini from "./pages/Tirocini";
import AdminAvvisi from "./pages/AdminAvvisi";
import AdminResetPassword from "./pages/AdminResetPassword";
import TrasparenzaIA from "./pages/TrasparenzaIA";
import ReteAccordi from "./pages/ReteAccordi";
import AccordoDettaglio from "./pages/AccordoDettaglio";
import RiskExperience from "./pages/RiskExperience";
import AnteprimaRestyling from "./pages/AnteprimaRestyling";
import ModuloAnteprima from "./pages/ModuloAnteprima";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/termini-condizioni" element={<TerminiCondizioni />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/reclami" element={<Reclami />} />
          <Route path="/precontrattuale" element={<Precontrattuale />} />
          <Route path="/societa-benefit" element={<SocietaBenefit />} />
          <Route path="/societa-cooperativa" element={<SocietaCooperativa />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/quotazione" element={<Quotazione />} />
          <Route path="/basta-la-targa" element={<BastaLaTarga />} />
          <Route path="/trasparenza-reclami" element={<TrasparenzaReclami />} />
          <Route path="/tirocini" element={<Tirocini />} />
          <Route path="/admin/avvisi" element={<AdminAvvisi />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/trasparenza-ia" element={<TrasparenzaIA />} />
          <Route path="/rete-di-accordi" element={<ReteAccordi />} />
          <Route path="/rete-di-accordi/:slug" element={<AccordoDettaglio />} />
          <Route path="/risk-experience" element={<RiskExperience />} />
          <Route path="/anteprima-restyling" element={<AnteprimaRestyling />} />
          <Route path="/moduli/anteprima/:key" element={<ModuloAnteprima />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
